require('./bootstrap');

// Components
require('./components/utilities');
require('./components/disclaimer');
require('./components/colorbox');
require('./components/post');

// Blocks
require('./blocks/accordion');
require('./blocks/faqs');
require('./blocks/stats');
require('./blocks/tabs');
